const app = {
  pathToLibsFiles: './assets/libs',
};
window.app = app;

// polyfills
// before polyfills
(function (arr) {
  arr.forEach((item) => {
    if (item.hasOwnProperty('before')) {
      return;
    }
    Object.defineProperty(item, 'before', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function before() {
        // eslint-disable-next-line prefer-rest-params
        const argArr = Array.prototype.slice.call(arguments);
        const docFrag = document.createDocumentFragment();
        argArr.forEach((argItem) => {
          const isNode = argItem instanceof Node;
          docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
        });
        this.parentNode.insertBefore(docFrag, this);
      },
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

// forEach polyfill
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    // eslint-disable-next-line no-param-reassign
    thisArg = thisArg || window;
    for (let i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

// const preloader = () => {
//   const confirm = document.getElementById('confirm');

//   window.addEventListener('load', () => {
//     if (confirm) {
//       confirm.addEventListener('click', (e) => {
//         if (e.target.closest('.confirm-btn__open')) {
//           confirm.style.display = 'none';
//           setTimeout(() => {
//             iceCrash();
//           }, 500);
//         }
//       });
//     }
//   });
// };

// preloader();

const toggleMenu = () => {
  const popupMenu = document.querySelector('.popup-menu');
  const burger = document.querySelector('.burger');

  burger.addEventListener('click', () => {
    burger.classList.toggle('active');
    popupMenu.classList.toggle('active');
  });
};

toggleMenu();

const animateFirstScreen = () => {
  const bigJar = document.querySelector('.big-jar');
  const smallJarShadow = document.querySelector('.small-jar-shadow');
  const smallJar = document.querySelector('.small-jar');
  const veloMiniGroup = document.querySelector('.velo-mini-group');
  const firstScreenTitle = document.querySelector('.first-screen-title');
  const firstScreenSubtitle = document.querySelector('.first-screen-subtitle');
  const bw = document.body.clientWidth;

  if (bw > 1080) {
    setTimeout(() => {
      bigJar.classList.add('active');
    }, 20);
    setTimeout(() => {
      smallJar.classList.add('active');
      smallJarShadow.classList.add('active');
      firstScreenTitle.classList.add('active');
      firstScreenSubtitle.classList.add('active');
    }, 50);
    setTimeout(() => {
      veloMiniGroup.classList.add('active');
    }, 1000);
  }
};

animateFirstScreen();

const animate = () => {
  gsap.registerPlugin(ScrollTrigger);

  const bw = document.body.clientWidth;

  if (bw > 1024) {
    gsap.utils.toArray('.panel').forEach((panel) => {
      ScrollTrigger.create({
        trigger: panel,
        start: 'top top',
        pin: true,
        pinSpacing: false,
      });
    });

    gsap.to('.velo-mini__text', {
      scrollTrigger: {
        trigger: '.velo-mini',
        start: 'top center',
      },
      y: 0,
    });

    gsap.to('.velo-mint__triangle', {
      scrollTrigger: {
        trigger: '.velo-mini',
        start: 'top center',
      },
      left: 0,
    });

    gsap.to('.velo-mint__small-jar', {
      scrollTrigger: {
        trigger: '.velo-mini',
        start: 'top center',
      },
      /* eslint-disable-next-line */
      left: 25 + '%',
      /* eslint-disable-next-line */
      rotate: 360 + 'deg',
      delay: 0.3,
    });

    gsap.to('.velo-mint__big-jar', {
      scrollTrigger: {
        trigger: '.velo-mini',
        start: 'top center',
      },
      /* eslint-disable-next-line */
      left: 250 + 'px',
      /* eslint-disable-next-line */
      top: -90 + 'px',
      zIndex: 0,
      delay: 0.3,
    });

    gsap.to('.velo-mini-small', {
      scrollTrigger: {
        trigger: '.mini-adv__title',
        start: 'top center',
      },
      x: 55,
    });

    gsap.to('.velo-mini__jar', {
      scrollTrigger: {
        trigger: '.mini-adv__title',
        start: 'top center',
      },
      x: 55,
    });

    gsap.to('.velo-mini__jar2', {
      scrollTrigger: {
        trigger: '.mini-adv__title',
        start: 'top center',
      },
      x: 55,
    });

    gsap.to('.inside-velo__wrapper', {
      scrollTrigger: {
        trigger: '.inside-velo',
        start: 'top center',
      },
      opacity: 1,
    });

    gsap.to('.use-velo__list', {
      scrollTrigger: {
        trigger: '.use-velo__title',
        start: 'top center',
      },
      opacity: 1,
      y: 0,
    });

    // ScrollTrigger.defaults({
    //   toggleActions: "restart pause resume pause",
    //   scroller: ".test"
    // });
  }

  if (bw < 1400 && bw > 1050) {
    gsap.to('.velo-mint__big-jar', {
      scrollTrigger: {
        trigger: '.velo-mini',
        start: 'top center',
      },
      /* eslint-disable-next-line */
      left: 172 + 'px',
      /* eslint-disable-next-line */
      top: -55 + 'px',
      zIndex: 0,
      delay: 0.3,
    });
  }
};

animate();

const swiperInit = () => {
  /* eslint-disable-next-line */
  let mediumSlider;
  const bw = document.body.clientWidth;
  const mediumSliderInit = document.querySelector('.medium-slider');
  const initSlider = document.querySelector('.init-slider');
  /* eslint-disable-next-line */
  if (bw < 576) {
    mediumSliderInit.classList.add('swiper');
    initSlider.classList.add('swiper-wrapper');
    mediumSlider = new Swiper('.medium-slider', {
      slidesPerView: 3.5,
      spaceBetween: 20,
      slideToClickedSlide: true,
      grabCursor: true,
      scrollbar: {
        el: '.swiper-scrollbar',
        dragSize: 500,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          scrollbar: {
            dragSize: 200,
          },
          centeredSlides: true,
          loop: true,
          spaceBetween: 0,
        },
        690: {
          slidesPerView: 2,
        },
        1300: {
          slidesPerView: 3.5,
        },
      },
    });
  } else {
    mediumSliderInit.classList.remove('swiper');
    initSlider.classList.remove('swiper-wrapper');
  }
};

swiperInit();

const test = () => {
  /* eslint-disable-next-line */
  let advancedSlider;
  const bw = document.body.clientWidth;
  const mediumSliderInit = document.querySelector('.advanced-slider');
  const initSlider = document.querySelector('.init-adv-slider');
  /* eslint-disable-next-line */
  if (bw < 576) {
    mediumSliderInit.classList.add('swiper');
    initSlider.classList.add('swiper-wrapper');
    advancedSlider = new Swiper('.advanced-slider', {
      slidesPerView: 3.1,
      grabCursor: true,
      scrollbar: {
        el: '.swiper-scrollbar',
        dragSize: 500,
        hide: false,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          scrollbar: {
            dragSize: 200,
          },
          centeredSlides: true,
          loop: true,
        },
        690: {
          slidesPerView: 2,
        },
        1300: {
          slidesPerView: 3.1,
        },
      },
    });
  } else {
    mediumSliderInit.classList.remove('swiper');
    initSlider.classList.remove('swiper-wrapper');
  }
};

test();

const slider1 = () => {
  /* eslint-disable-next-line */
  let advancedSlider;
  /* eslint-disable-next-line */
  advancedSlider = new Swiper('.inside-velo__wrapper', {
    slidesPerView: 4,

    grabCursor: true,
    breakpoints: {
      320: {
        slidesPerView: 1.7,
        centeredSlides: true,
        spaceBetween: 2,
        loop: true,
      },
      445: {
        slidesPerView: 2.2,
        spaceBetween: 50,
        centeredSlides: true,
        loop: true,
      },
      690: {
        slidesPerView: 4,
      },
    },
  });
};

slider1();

const slider2 = () => {
  /* eslint-disable-next-line */
  let useSlider;
  /* eslint-disable-next-line */
  useSlider = new Swiper('.use-velo__list', {
    slidesPerView: 4,
    spaceBetween: 40,

    grabCursor: true,
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 40,
        centeredSlides: true,
        loop: true,
      },
      690: {
        slidesPerView: 4,
      },
    },
  });
};

slider2();

const slider3 = () => {
  /* eslint-disable-next-line */
  let bestSlider;
  /* eslint-disable-next-line */
  bestSlider = new Swiper('.best-velo-slider', {
    slidesPerView: 3.1,
    grabCursor: true,
    scrollbar: {
      el: '.swiper-scrollbar',
      dragSize: 500,
      hide: false,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1.5,
        spaceBetween: 0,
        loop: true,
        centeredSlides: true,
        scrollbar: {
          dragSize: 200,
        },
      },
      690: {
        slidesPerView: 2,
      },
      1300: {
        slidesPerView: 3.1,
      },
    },
  });
};

slider3();

const veloMiniSlider = () => {
  /* eslint-disable-next-line */
  let veloMini;
  /* eslint-disable-next-line */
  veloMini = new Swiper('.mini-adv__slider', {
    slidesPerView: 3,
    grabCursor: true,
    navigation: {
      prevEl: '.arrow-prev',
      nextEl: '.arrow-next',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        centeredSlides: true,
      },
      690: {
        slidesPerView: 2,
        spaceBetween: 50,
      },
      1150: {
        slidesPerView: 3,
      },
    },
  });
};

veloMiniSlider();

const sashe = () => {
  /* eslint-disable-next-line */
  let sasheSlider;
  const bw = document.body.clientWidth;
  const mediumSliderInit = document.querySelector('.sashe-slider');
  const initSlider = document.querySelector('.init-sashe');

  if (bw < 576) {
    mediumSliderInit.classList.add('swiper');
    initSlider.classList.add('swiper-wrapper');
    /* eslint-disable-next-line */
    sasheSlider = new Swiper('.sashe-slider', {
      slidesPerView: 3.1,
      grabCursor: true,
      breakpoints: {
        320: {
          slidesPerView: 1.8,
          centeredSlides: true,
          loop: true,
          spaceBetween: 20,
        },
        690: {
          slidesPerView: 2,
        },
        1300: {
          slidesPerView: 3.1,
        },
      },
    });
  } else {
    mediumSliderInit.classList.remove('swiper');
    initSlider.classList.remove('swiper-wrapper');
  }
};

sashe();

// const firstScreenMobile = () => {
//   const bw = document.body.clientWidth;
//
//   if (bw < 576) {
//     const jar = document.querySelector('.jar-block').children;
//     const triangle = document.querySelector('.last-screen__triangle').children;
//     const text = document.querySelector('.last-screen__text').children;
//     jar[0].src = 'assets/images/jar_mobile.png';
//     triangle[0].src = 'assets/images/triangle_mobile.png';
//     text[0].src = 'assets/images/ru_text_mobile.png';
//   }
// };
//
// firstScreenMobile();
